import { createAsyncThunk } from "@reduxjs/toolkit";
import { raiseError } from "../actions/action";
import apiRequest from "./apiRequest";

const changePassword = createAsyncThunk('change/password', async (passwordDetails, { dispatch }) => {
    try {
        const response = await apiRequest.put(`/user/changePassword`, passwordDetails);
        return (response);
    } catch (error) {
        dispatch(raiseError("Something went wrong. please try after sometime"));
    }
});

export { changePassword };